import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { BrandHeader } from "@/components/BrandHeader";
import { toast } from "sonner";
import { Loader2, ShieldCheck, CheckCircle2 } from "lucide-react";

const inputCls = "w-full rounded-xl border-2 border-slate-200 focus:border-[#003284] outline-none px-4 py-2.5 transition-colors";

export default function ResetPasswordPage() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const navigate = useNavigate();
  const { loginUser } = useApp();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("La contraseña debe tener al menos 6 caracteres");
    if (password !== confirm) return toast.error("Las contraseñas no coinciden");
    setLoading(true);
    try {
      const { data } = await api.post("/user/reset-password", { token, password });
      loginUser(data.token, data.user);
      setDone(true);
      setTimeout(() => navigate("/inicio"), 1800);
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo restablecer la contraseña");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]"><BrandHeader />
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="bg-white rounded-3xl shadow-lg p-8">
          {done ? (
            <div className="text-center space-y-3" data-testid="reset-done">
              <CheckCircle2 className="mx-auto text-emerald-500" size={56} />
              <h1 className="text-2xl font-black brand-navy">Contraseña actualizada</h1>
              <p className="text-slate-500">Ya has iniciado sesión. Te llevamos a la web…</p>
            </div>
          ) : !token ? (
            <div className="text-center space-y-3">
              <h1 className="text-2xl font-black brand-navy">Enlace no válido</h1>
              <p className="text-slate-500">Falta el token de restablecimiento. Solicita un nuevo enlace desde tu cuenta.</p>
              <button data-testid="reset-goto-account" onClick={() => navigate("/cuenta")} className="w-full bg-brand-navy text-white font-bold rounded-full py-3.5 hover:bg-[#FF7F27] transition-colors">Ir a mi cuenta</button>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-black brand-navy text-center">Nueva contraseña</h1>
              <p className="text-center text-slate-500 mt-2 mb-6">Elige una contraseña nueva para tu cuenta.</p>
              <form onSubmit={submit} className="space-y-3">
                <input data-testid="reset-password" type="password" className={inputCls} placeholder="Nueva contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <input data-testid="reset-password-confirm" type="password" className={inputCls} placeholder="Repite la contraseña" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
                <button data-testid="reset-submit" disabled={loading} className="w-full bg-brand-orange text-white font-bold rounded-full py-3.5 hover:bg-[#DE7A1C] disabled:opacity-50 transition-colors flex items-center justify-center gap-2">{loading ? <Loader2 className="animate-spin" size={18} /> : <><ShieldCheck size={18} /> Guardar contraseña</>}</button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
